import React from 'react'

const TableFilter = (props) => {
  const {
    colTitle,
    setSortField,
    setSortOrder,
    sortFieldValue,
    sortField,
    sortOrder,
    arrowFilter,
  } = props;
  const isActive = sortField === sortFieldValue;
  return (
    <div className='d-flex flex-row justify-content-evenly align-items-center'>
      <span className={`${!arrowFilter ? 'mb-1' : ''}`}>{colTitle}</span>
      {arrowFilter ? (
        <div className='d-flex flex-column'>
          <i
            className={`bi ${
              isActive && (sortOrder === 'asc' || sortOrder === 'ASC')
                ? 'bi-caret-up-fill'
                : 'bi-caret-up'
            } ${
              isActive && (sortOrder === 'asc' || sortOrder === 'ASC')
                ? 'text-primary'
                : 'text-muted'
            }`}
            onClick={() => {
              setSortField(sortFieldValue)
              setSortOrder('asc')
            }}
            style={{cursor: 'pointer'}}
          ></i>
          <i
            className={`bi ${
              isActive && (sortOrder === 'desc' || sortOrder === 'DESC')
                ? 'bi-caret-down-fill'
                : 'bi-caret-down'
            } ${
              isActive && (sortOrder === 'desc' || sortOrder === 'DESC')
                ? 'text-primary'
                : 'text-muted'
            }`}
            onClick={() => {
              setSortField(sortFieldValue)
              setSortOrder('desc')
            }}
            style={{cursor: 'pointer'}}
          ></i>
        </div>
      ) : null}
    </div>
  )
}

export default TableFilter